// Wrappers seguros para Storage del navegador.
// Algunos navegadores (in-app como el de WhatsApp, modo privado, o privacidad
// alta) lanzan SecurityError al tocar localStorage/sessionStorage. Sin guard,
// leer storage durante el render crashea toda la app (Sentry RAPPI-POP-FRONTEND-2:
// "SecurityError: Failed to read the 'localStorage' property... Access is denied").
// Estos helpers degradan en vez de crashear: get devuelve null, set devuelve false.
function makeSafe(getStore) {
  return {
    getItem(key) {
      try { return getStore().getItem(key); } catch { return null; }
    },
    setItem(key, value) {
      try { getStore().setItem(key, value); return true; } catch { return false; }
    },
    removeItem(key) {
      try { getStore().removeItem(key); } catch { /* noop */ }
    },
  };
}

export const safeLocal = makeSafe(() => window.localStorage);
export const safeSession = makeSafe(() => window.sessionStorage);
